export default __webpack_public_path__ + "static/appStore-be6e1c8a29b1e9b10845cb8e8added2a.webp";